import React, { useEffect, useMemo, useState } from "react";
import { Container, UncontrolledTooltip, Form, FormGroup, Label, Input, Button, Row, Col, Card, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import TableContainer from '../../../components/Common/TableContainer';

// Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import Select from 'react-select';
import {
  fetchCategories,
  fetchDepartments,
  fetchDesignations,
  fetchEmployees,
} from "store/actions";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { urlEncryptData } from "../../../helpers/crypto_helper"
import { FadeLoader } from "react-spinners";
import Loader from "common/pageLoader";
import { exportExcelFile } from "common/ExportExcelFile";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { useLocation, useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

// select custome style
const SelectcustomStyles = {
  control: (base) => ({
    ...base,
    maxheight: 42,
    minHeight: 42,
    // overflow: "scroll",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0", // Match the padding for both dropdown and clear indicator
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "2px 8px", // Ensure consistent padding for dropdown indicator
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
  }),
};

const EmployeeDetails = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    const rights = getAccessRights(location.pathname, history);
    setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete } = useButtonAccess(accessRight);

  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    categories,
    departments,
    designations,
    employees,
    loading,
    error,
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories ?? [],
    departments: state.DepartmentMaster?.departments ?? [],
    designations: state.DesignationMaster?.designations ?? [],
    employees: state.EmployeeDetailsReducer?.employees ?? [],

    loading: state.CategoryMaster?.loading || state.DepartmentMaster?.loading || state.DesignationMaster?.loading || state.EmployeeDetailsReducer?.loading,
    error: state.CategoryMaster?.error || state.DepartmentMaster?.error || state.DesignationMaster?.error || state.EmployeeDetailsReducer?.error,
  }));
  // const [filteredData, setFilteredData] = useState(data); 
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));

    const formData = new FormData();
    formData.append("unit_id", unitId);
    formData.append("cat_id", '');
    formData.append("dept_id", '');
    formData.append("desig_id", '');
    formData.append("create_by", authUserDetails[0]?.user_id);
    formData.append("emp_code", 0);
    formData.append("emp_name", '');
    formData.append("emp_status", 1);

    dispatch(fetchEmployees(formData));
  }, [dispatch]);

  const safeEncrypt = (value) => {
    if (!value) return "";
    return encodeURIComponent(urlEncryptData(String(value)));
  };

  const columns = useMemo(() => [
    ...(canEdit || canRead ? [
      {
        Header: "Action",
        Cell: ({ row }) => {
          const empId = row.original?.emp_id;
          const userId = row.original?.user_id;

          return (
            <div className="d-flex justify-content-center gap-3">

              {(canEdit || canRead) && (
                <Link
                  to={`/my-profile?id=${safeEncrypt(empId)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary"
                >
                  <i className="fas fa-user font-size-18"
                    id={`viewtooltip-${empId}`} />
                  <UncontrolledTooltip
                    placement="top"
                    target={`viewtooltip-${empId}`}
                  >
                    View Employee Details
                  </UncontrolledTooltip>
                </Link>
              )}

              {canRead && (
                <Link
                  to={`/my-attendance?id=${safeEncrypt(userId)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-info"
                >
                  <i className="fas fa-calendar-alt font-size-18"
                    id={`calendartooltip-${empId}`} />
                  <UncontrolledTooltip
                    placement="top"
                    target={`calendartooltip-${empId}`}
                  >
                    View Employee Status
                  </UncontrolledTooltip>
                </Link>
              )}

              {canEdit && (
                <Link
                  to={`/employee-details?id=${safeEncrypt(empId)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-success"
                >
                  <i className="bx bxs-edit font-size-18"
                    id={`edittooltip-${empId}`} />
                  <UncontrolledTooltip
                    placement="top"
                    target={`edittooltip-${empId}`}
                  >
                    Edit Employee Details
                  </UncontrolledTooltip>
                </Link>
              )}

            </div>
          );
        },
      }
    ] : []),
    {
      Header: "S.No",
      className: "serial-no",
      applyHeaderClass: true,
      Cell: ({ row }) => employees.length - row.index,
    },
    // {
    //   Header: "Action",
    //   Cell: (cellProps) => {
    //     const isActive = cellProps.row.original.status;
    //     const empId = cellProps.row.original?.emp_id;
    //     const userId = cellProps.row.original?.user_id;
    //     return (
    //       <div className="d-flex gap-3">
    //         {/* <Link to={`/view-profile?id=${encodeURIComponent(urlEncryptData(`${empId}`))}`} className="text-primary" > */}
    //         <Link to={`/my-profile?id=${encodeURIComponent(urlEncryptData(`${empId}`))}`} className="text-primary" >
    //           <i className="fas fa-user font-size-18" id={`viewtooltip-${empId}`} />
    //           <UncontrolledTooltip placement="top" target={`viewtooltip-${empId}`}>
    //             View Employee Details
    //           </UncontrolledTooltip>
    //         </Link>
    //         <Link to={`/my-attendance?id=${encodeURIComponent(urlEncryptData(`${userId}`))}`}
    //           className="text-info"
    //         >
    //           <i className="fas fa-calendar-alt font-size-18" id={`calendartooltip-${empId}`} />
    //           <UncontrolledTooltip placement="top" target={`calendartooltip-${empId}`}>
    //             View Employee Status
    //           </UncontrolledTooltip>
    //         </Link>
    //         <Link
    //           // to="#"
    //           className="text-success"
    //           to={`/employee-details?id=${encodeURIComponent(urlEncryptData(`${empId}`))}`}
    //         >
    //           <i className="bx bxs-edit font-size-18" id={`edittooltip-${empId}`} />
    //           <UncontrolledTooltip placement="top" target={`edittooltip-${empId}`} >
    //             Edit Employee Details
    //           </UncontrolledTooltip>
    //         </Link>
    //       </div>
    //     );
    //   },
    // },
    //  {
    //   Header: "Action",
    //   Cell: (cellProps) => {
    //     const empId = cellProps.row.original?.emp_id;
    //     const userId = cellProps.row.original?.user_id;

    //     return (
    //       <div className="d-flex justify-content-center gap-3">

    //         {canEdit && (
    //           <Link
    //             to={`/my-profile?id=${safeEncrypt(empId)}`}
    //             className="text-primary"
    //           >
    //             <i className="fas fa-user font-size-18"
    //                id={`viewtooltip-${empId}`} />
    //             <UncontrolledTooltip
    //               placement="top"
    //               target={`viewtooltip-${empId}`}
    //             >
    //               View Employee Details
    //             </UncontrolledTooltip>
    //           </Link>
    //         )}

    //         {canRead && (
    //           <Link
    //             to={`/my-attendance?id=${safeEncrypt(userId)}`}
    //             className="text-info"
    //           >
    //             <i className="fas fa-calendar-alt font-size-18"
    //                id={`calendartooltip-${empId}`} />
    //             <UncontrolledTooltip
    //               placement="top"
    //               target={`calendartooltip-${empId}`}
    //             >
    //               View Employee Status
    //             </UncontrolledTooltip>
    //           </Link>
    //         )}

    //         {canEdit && (
    //           <Link
    //             to={`/employee-details?id=${safeEncrypt(empId)}`}
    //             className="text-success"
    //           >
    //             <i className="bx bxs-edit font-size-18"
    //                id={`edittooltip-${empId}`} />
    //             <UncontrolledTooltip
    //               placement="top"
    //               target={`edittooltip-${empId}`}
    //             >
    //               Edit Employee Details
    //             </UncontrolledTooltip>
    //           </Link>
    //         )}

    //       </div>
    //     );
    //   },
    // },
    {
      Header: "Code",
      accessor: "emp_no",  // Maps to employeeId field
    },
    {
      Header: "Employee Name",
      accessor: "emp_name",  // Maps to employeeName field
    },
    {
      Header: "Category",
      accessor: "category",  // Maps to category field
      // Cell: ({ value }) => {
      //   const category = categoryData.find((cat) => cat.id === value);
      //   return category ? category.name : value; // Display the category name instead of id
      // },
    },
    {
      Header: "Department",
      accessor: "department",  // Maps to department field
      // Cell: ({ value }) => {
      //   const department = departmentData.find((dept) => dept.id === value);
      //   return department ? department.name : value; // Display the department name instead of id
      // },
    },
    {
      Header: "Designation",
      accessor: "designation",  // Maps to designation field
      // Cell: ({ value }) => {
      //   const designation = designationData.find((desig) => desig.id === value);
      //   return designation ? designation.name : value; // Display the designation name instead of id
      // },
    },
    {
      Header: "Reporting",
      accessor: "reporting_to",  // Maps to reporting field
    },
    {
      Header: "Gender",
      accessor: "gender",  // Maps to gender field
    },
    {
      Header: "Age",
      accessor: "emp_age",  // Maps to age field
    },
    {
      Header: "Join Date",
      accessor: "join_date",  // Maps to joinDate field
      // Cell: ({ value }) => new Date(value).toLocaleDateString(), // Formatting the join date
    },
    {
      Header: "Experience",
      accessor: "experience",  // Maps to experience field
    },
    // {
    //   Header: "Nature",
    //   accessor: "emp_nature",  // Maps to nature field
    // },
    {
      Header: "Pay Type",
      accessor: "pay_type",  // Maps to payType field
    },
    {
      Header: "Salary Type",
      accessor: "salary_type",  // Maps to salaryType field
    },
    {
      Header: "Employement Type",
      accessor: "emplment_type_name",
    },
    {
      Header: () => (
        <>
          <span id="sal-header-tooltip" style={{ cursor: "pointer" }}>
            SAL
          </span>
          <UncontrolledTooltip placement="top" target="sal-header-tooltip">
            Salary Processed by Hourly Wages
          </UncontrolledTooltip>
        </>
      ),
      accessor: "sal_fixed",
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`}
          style={{ color: value ? "green" : "red" }}
        />
      ),
    },
    {
      Header: () => (
        <>
          <span id="esi-header-tooltip" style={{ cursor: "pointer" }}>
            ESI
          </span>
          <UncontrolledTooltip placement="top" target="esi-header-tooltip">
            ESI Not Applicable
          </UncontrolledTooltip>
        </>
      ),
      accessor: "esi_not_eligible",  // Boolean field for ESI
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
    {
      Header: () => (
        <>
          <span id="pf-header-tooltip" style={{ cursor: "pointer" }}>
            PF
          </span>
          <UncontrolledTooltip placement="top" target="pf-header-tooltip">
            PF Not Applicable
          </UncontrolledTooltip>
        </>
      ),
      accessor: "pf_not_eligible",  // Boolean field for PF
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
    {
      Header: () => (
        <>
          <span id="wo-header-tooltip" style={{ cursor: "pointer" }}>
            WO
          </span>
          <UncontrolledTooltip placement="top" target="wo-header-tooltip">
            Week off
          </UncontrolledTooltip>
        </>
      ),
      accessor: "is_extra_eli",  // Boolean field for WO
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
    {
      Header: () => (
        <>
          <span id="eh-header-tooltip" style={{ cursor: "pointer" }}>
            EH
          </span>
          <UncontrolledTooltip placement="top" target="eh-header-tooltip">
            Extra Hours
          </UncontrolledTooltip>
        </>
      ),
      accessor: "is_extra_duty",  // Boolean field for EH
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
    {
      Header: () => (
        <>
          <span id="inc-header-tooltip" style={{ cursor: "pointer" }}>
            INC
          </span>
          <UncontrolledTooltip placement="top" target="inc-header-tooltip">
            Incentive
          </UncontrolledTooltip>
        </>
      ),
      accessor: "is_incentive",  // Boolean field for INC
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
    {
      Header: () => (
        <>
          <span id="late-header-tooltip" style={{ cursor: "pointer" }}>
            LATE
          </span>
          <UncontrolledTooltip placement="top" target="late-header-tooltip">
            Shift Late
          </UncontrolledTooltip>
        </>
      ),
      accessor: "is_shift_late",  // Boolean field for LATE
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
    {
      Header: () => (
        <>
          <span id="per-header-tooltip" style={{ cursor: "pointer" }}>
            PER
          </span>
          <UncontrolledTooltip placement="top" target="per-header-tooltip">
            Permission
          </UncontrolledTooltip>
        </>
      ),
      accessor: "is_permission",  // Boolean field for PER
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
    {
      Header: () => (
        <>
          <span id="hw-header-tooltip" style={{ cursor: "pointer" }}>
            HW
          </span>
          <UncontrolledTooltip placement="top" target="hw-header-tooltip">
            Hourly Wages
          </UncontrolledTooltip>
        </>
      ),
      accessor: "hourly_wages",  // Boolean field for HW
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
    // {
    //   Header: "Hrs",
    //   accessor: "hrs_wrked",  // Numeric field for Hrs
    //   Cell: ({ value }) => value || 0,
    // },
    {
      Header: () => (
        <>
          <span id="atr-header-tooltip" style={{ cursor: "pointer" }}>
            ATR
          </span>
          <UncontrolledTooltip placement="top" target="atr-header-tooltip">
            Attendance Not Required
          </UncontrolledTooltip>
        </>
      ),
      accessor: "att_not_required",  // Boolean field for ATR
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
    {
      Header: () => (
        <>
          <span id="eawf-header-tooltip" style={{ cursor: "pointer" }}>
            E-AWF
          </span>
          <UncontrolledTooltip placement="top" target="eawf-header-tooltip">
            Eliminate App Workflow
          </UncontrolledTooltip>
        </>
      ),
      accessor: "eliminate_app_workflow",  // Boolean field for E-AWF
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
    {
      Header: () => (
        <>
          <span id="maa-header-tooltip" style={{ cursor: "pointer" }}>
            MAA
          </span>
          <UncontrolledTooltip placement="top" target="maa-header-tooltip">
            Marker Auto Approval
          </UncontrolledTooltip>
        </>
      ),
      accessor: "auto_approval",
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
    {
      Header: () => (
        <>
          <span id="el-header-tooltip" style={{ cursor: "pointer" }}>
            EL
          </span>
          <UncontrolledTooltip placement="top" target="el-header-tooltip">
            Earned Leave
          </UncontrolledTooltip>
        </>
      ),
      accessor: "is_el",
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
    {
      Header: () => (
        <>
          <span id="psu-header-tooltip" style={{ cursor: "pointer" }}>
            PSU
          </span>
          <UncontrolledTooltip placement="top" target="psu-header-tooltip">
            Punch Based Shift Update
          </UncontrolledTooltip>
        </>
      ),
      accessor: "punch_based_shift",
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
    {
      Header: () => (
        <>
          <span id="mu-header-tooltip" style={{ cursor: "pointer" }}>
            Mob. User
          </span>
          <UncontrolledTooltip placement="top" target="mu-header-tooltip">
            Mobile User
          </UncontrolledTooltip>
        </>
      ),
      accessor: "is_mob_usr",
      Cell: ({ value }) => (
        <i
          className={`mdi ${value ? 'mdi-check-circle' : 'mdi-close-circle'} font-size-18`}
          style={{ color: value ? 'green' : 'red' }}
        />
      ),
    },
  ], [employees, canRead, canEdit]);


  const formik = useFormik({
    initialValues: {
      category: [],
      department: [],
      designation: [],
      employeeCode: "",
      employeeName: "",
      empStatus: "Active",
    },
    onSubmit: (values) => {

      const formData = new FormData();
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("cat_id", values.category.length ? values.category.join(",") : '');
      formData.append("dept_id", values.department.length ? values.department.join(",") : '');
      formData.append("desig_id", values.designation.length ? values.designation.join(",") : '');
      formData.append("create_by", authDetails?.user_id || '');
      formData.append("emp_code", values.employeeCode || 0);
      formData.append("emp_name", values.employeeName || '');
      formData.append("emp_status", values.empStatus === "Active" ? "1" : "2");

      dispatch(fetchEmployees(formData));

      // Filter the data when the form is submitted
      // const filtered = data.filter(item => {
      //   const matchesCategory = values.category.length === 0 || values.category.includes(item.categoryId);
      //   const matchesDepartment = values.department.length === 0 || values.department.includes(item.departmentId);
      //   const matchesDesignation = values.designation.length === 0 || values.designation.includes(item.designationId);
      //   const matchesEmployeeCode = !values.employeeCode || item.employeeId.toLowerCase().includes(values.employeeCode.toLowerCase());
      //   const matchesEmployeeName = !values.employeeName || item.employeeName.toLowerCase().includes(values.employeeName.toLowerCase());
      //   const matchesEmpStatus = !values.empStatus || item.status === values.empStatus;

      //   return matchesCategory && matchesDepartment && matchesDesignation && matchesEmployeeCode && matchesEmployeeName && matchesEmpStatus;
      // });

      // setFilteredData(filtered);
    },
  });

  const handleCancel = () => {
    formik.resetForm();
    const formData = new FormData();
    formData.append("unit_id", authDetails.unit_id);
    formData.append("cat_id", '');
    formData.append("dept_id", '');
    formData.append("desig_id", '');
    formData.append("create_by", authDetails.user_id);
    formData.append("emp_code", 0);
    formData.append("emp_name", '');
    formData.append("emp_status", 1);

    dispatch(fetchEmployees(formData));
    // setFilteredData(data)
  };

  const handleCreate = () => {
    console.log("handleCreate");
  };

  // const handleExport = () => {
  //   console.log("handleExport");

  //   // Sample data (Replace this with actual data)
  //   // const data = [
  //   //   { Name: "John Doe", Age: 30, Email: "john@example.com" },
  //   //   { Name: "Jane Smith", Age: 25, Email: "jane@example.com" },
  //   // ];

  //   // if (data.length === 0) {
  //   //   alert("No data to export!");
  //   //   return;
  //   // }

  //   // // Convert JSON to CSV
  //   // const headers = Object.keys(data[0]).join(",") + "\n"; // Column headers
  //   // const rows = data.map(row => Object.values(row).join(",")).join("\n");

  //   // const csvContent = headers + rows;

  //   // // Create a Blob
  //   // const blob = new Blob([csvContent], { type: "text/csv" });
  //   // const url = URL.createObjectURL(blob);

  //   // // Create download link
  //   // const a = document.createElement("a");
  //   // a.href = url;
  //   // a.download = "exported_data.csv";
  //   // document.body.appendChild(a);
  //   // a.click();
  //   // document.body.removeChild(a);

  //   // // Clean up
  //   // URL.revokeObjectURL(url);
  // };


  const handleExport = () => {
    if (!Array.isArray(employees) || employees.length === 0) {
      toast.error("No data to export.");
      return;
    }

    const exportData = employees.map((item, index) => {
      const row = {};

      columns.forEach((col) => {
        try {
          if (col.accessor) {
            // Safely get data using accessor
            row[col.Header] = item?.[col.accessor] ?? "";
          } else if (col.Cell && typeof col.Cell === "function") {
            // Safely call custom Cell renderers
            const cellValue = col.Cell({
              row: { index, original: item },
              value: item,
            });

            // Only assign simple text or numbers, skip React elements
            row[col.Header] =
              typeof cellValue === "string" || typeof cellValue === "number"
                ? cellValue
                : "";
          } else {
            // Skip columns without accessor or Cell
            row[col.Header] = "";
          }
        } catch (err) {
          console.warn(`Error processing column ${col.Header}:`, err);
          row[col.Header] = "";
        }
      });

      return row;
    });

    exportExcelFile({
      data: exportData,
      fileNamePrefix: "EmployeeDetails",
      sheetName: "Employee",
    });
  };

  const [loader, setLoader] = useState(true);

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading} />
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Employee" breadcrumbItem="Employee Details" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <Form onSubmit={formik.handleSubmit}>
                    <Row>
                      {/* Category Multi-Select */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="category">Category</Label>
                          <Select
                            id="category"
                            name="category"
                            options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                            value={
                              categories
                                .filter(cat => formik.values.category?.includes(cat.empCatgryid))
                                .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                            }
                            onChange={val => formik.setFieldValue('category', val ? val.map(v => v.value) : [])}
                            isMulti
                            onBlur={formik.handleBlur}
                            className={`select-dropdown ${formik.touched.category && formik.errors.category ? 'is-invalid' : ''}`}
                            styles={SelectcustomStyles}
                          />
                          {formik.touched.category && formik.errors.category && (
                            <div className="text-danger">{formik.errors.category}</div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Department Multi-Select */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="department">Department</Label>
                          <Select
                            id="department"
                            name="department"
                            options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                            value={
                              departments
                                .filter(dept => formik.values.department?.includes(dept.departmentId))
                                .map(dept => ({ value: dept.departmentId, label: dept.departmentname }))
                            }
                            onChange={val => formik.setFieldValue('department', val ? val.map(v => v.value) : [])}
                            isMulti
                            onBlur={formik.handleBlur}
                            className={`select-dropdown ${formik.touched.department && formik.errors.department ? 'is-invalid' : ''}`}
                            styles={SelectcustomStyles}

                          />
                          {formik.touched.department && formik.errors.department && (
                            <div className="text-danger">{formik.errors.department}</div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Designation Multi-Select */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="designation">Designation</Label>
                          <Select
                            id="designation"
                            name="designation"
                            options={designations.map(desig => ({ value: desig.desig_id, label: desig.designation }))}
                            value={
                              designations
                                .filter(desig => formik.values.designation?.includes(desig.desig_id))
                                .map(desig => ({ value: desig.desig_id, label: desig.designation }))
                            }
                            onChange={val => formik.setFieldValue('designation', val ? val.map(v => v.value) : [])}
                            isMulti
                            onBlur={formik.handleBlur}
                            className={`select-dropdown ${formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''}`}
                            styles={SelectcustomStyles}

                          />
                          {formik.touched.designation && formik.errors.designation && (
                            <div className="text-danger">{formik.errors.designation}</div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Employee Code Input */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="employeeCode">Employee Code</Label>
                          <Input
                            id="employeeCode"
                            name="employeeCode"
                            type="text"
                            value={formik.values.employeeCode}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.employeeCode && formik.errors.employeeCode}
                          />
                          {formik.touched.employeeCode && formik.errors.employeeCode && (
                            <div className="text-danger">{formik.errors.employeeCode}</div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Employee Name Input */}
                      <Col md={3} sm={12} className="mb-3">
                        <FormGroup>
                          <Label for="employeeName">Employee Name</Label>
                          <Input
                            id="employeeName"
                            name="employeeName"
                            type="text"
                            value={formik.values.employeeName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.employeeName && formik.errors.employeeName}
                          />
                          {formik.touched.employeeName && formik.errors.employeeName && (
                            <div className="text-danger">{formik.errors.employeeName}</div>
                          )}
                        </FormGroup>
                      </Col>

                      {/* Employee Status Radio Buttons */}
                      <Col md={3} sm={12}>
                        <FormGroup>
                          <Label className="mb-2">Employee Status</Label>
                          <div className="d-flex align-items-center gap-3">
                            <Label className="d-flex align-items-center gap-2">
                              <Input
                                type="radio"
                                name="empStatus"
                                value="Active"
                                checked={formik.values.empStatus === 'Active'}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                              Active
                            </Label>
                            <Label className="d-flex align-items-center gap-2">
                              <Input
                                type="radio"
                                name="empStatus"
                                value="Resigned"
                                checked={formik.values.empStatus === 'Resigned'}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                              Resigned
                            </Label>
                          </div>
                          {formik.touched.empStatus && formik.errors.empStatus && (
                            <div className="text-danger">{formik.errors.empStatus}</div>
                          )}
                        </FormGroup>
                      </Col>


                      {/* Buttons */}
                      {/* <Col md={12} sm={12} className="d-flex justify-content-center gap-2 flex-wrap"> */}
                      {/* <Col className="d-flex mob-center align-items-center justify-content-end mt-2">
                        <Button type="submit" className="btn button-search me-2">
                          <i className="fas fa-search me-1" /> Search
                        </Button>

                        <Button type="reset" className="btn button-cancel me-2" onClick={handleCancel}>
                          <i className="fas fa-sync me-1" /> Cancel
                        </Button>
                        <Link to={`/employee-details?id=${encodeURIComponent(urlEncryptData("0"))}`} className="">
                          <Button type="button" className="btn button-add me-2">
                            <i className="fas fa-plus me-1" /> Create
                          </Button>
                        </Link>
                        <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                          <DropdownToggle color="primary" className="btn button-export mt-0">
                            <i className="fas fa-file-export me-1" /> Export
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem onClick={() => exportEmployeeToExcel(employees, authDetails?.unit_fullname, authDetails?.unit_address, "Employee Details")} >
                              <i className="fas fa-file-excel me-2 text-success" />
                              Export to Excel
                            </DropdownItem>
                            <DropdownItem onClick={() => exportEmployeeToPDF(employees, authDetails?.unit_fullname, authDetails?.unit_address, "Employee Details")}>
                              <i className="fas fa-file-pdf me-2 text-danger" />
                              Export to PDF
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>    
                      </Col> */}
                      <Col className="d-flex mob-center align-items-center justify-content-end mt-2">

                        {/* SEARCH always visible */}
                        <Button type="submit" className="btn button-search me-2">
                          <i className="fas fa-search me-1" /> Search
                        </Button>

                        {/* CANCEL always visible */}
                        <Button type="reset" className="btn button-cancel me-2" onClick={handleCancel}>
                          <i className="fas fa-sync me-1" /> Cancel
                        </Button>

                        {/* CREATE - only if create_access = 1 */}
                        {canCreate && (
                          <Link to={`/employee-details?id=${encodeURIComponent(urlEncryptData("0"))}`}>
                            <Button type="button" className="btn button-add me-2">
                              <i className="fas fa-plus me-1" /> Create
                            </Button>
                          </Link>
                        )}

                        {/* EXPORT - only if read_access = 1 */}
                        {canRead && (
                          <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                            <DropdownToggle color="primary" className="btn button-export mt-0">
                              <i className="fas fa-file-export me-1" /> Export
                            </DropdownToggle>

                            <DropdownMenu>
                              <DropdownItem onClick={() => exportEmployeeToExcel(employees, authDetails?.unit_fullname, authDetails?.unit_address, "Employee Details")}>
                                <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                              </DropdownItem>

                              <DropdownItem onClick={() => exportEmployeeToPDF(employees, authDetails?.unit_fullname, authDetails?.unit_address, "Employee Details", columns)}>
                                <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        )}

                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={employees && employees.length > 0 ? employees : []}
                    isGlobalFilter={true}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
              {/* <Card>
                <CardBody>
                  <Row>
                    <Col md={12} className="relative">
                      {loader && (
                        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-10">
                          <FadeLoader color="#4A90E2" />
                        </div>
                      )}
                      <TableContainer
                        columns={columns}
                        // data={employees && employees.length > 0 ? employees : []}
                        data={[]}
                        isGlobalFilter={true}
                        customPageSize={10}
                        className="custom-header-css"
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card> */}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>


  );
};

export default EmployeeDetails;
